import React, { useEffect } from 'react';

import { thankYouPageTitle } from '@/components/SubscriptionCard/SubscriptionCard.utils';
import SuccessfulOperationIndicator from '@/components/SVG/SuccessfulOperationIndicator';

const TopUpThankYouPage = () => {
  useEffect(() => {
    localStorage.removeItem('client_secret_checkout_top_up');
    document.title = thankYouPageTitle;
  }, []);

  return (
    <div className='flex justify-center items-center'>
      <div
        className='flex flex-col items-center gap-10'
        style={{ maxWidth: 678 }}
      >
        <SuccessfulOperationIndicator />

        <h1
          className='text-center font-serif font-bold'
          style={{ fontSize: 30, lineHeight: '35px' }}
        >
          Your Payment is Confirmed!
        </h1>

        <p
          className='leading-10 text-center text-18px'
          style={{ letterSpacing: '0.15px' }}
        >
          You’re one step closer to accessing all your EvoLux benefits. If
          you’re using a bank transfer, it may take a few days for ACH payments
          to be reflected in your account.
        </p>

        <a href='/search' className='btn'>
          Search for Flights
        </a>
      </div>
    </div>
  );
};

export default TopUpThankYouPage;
